// const utils = require('./utils')

import utils from './utils'
import system from './system'
import store from '@/store'

const dview = {
  pad: function (value, nItem = 2) {
    let aux = ''
    for (let i = 0; i < nItem; i++) aux = aux.concat('0')
    let result = aux.concat(value)
    result = result.substring(result.length - nItem, result.length)
    return result
  },

  isActive: function (availability, daysToAdd = 0, timeZone) {
    if (!timeZone) timeZone = store.state.app.TimeZone ? store.state.app.TimeZone : 'Europe/London'
    //console.log('ava', timeZone, store.state.app.TimeZone)

    if (!availability.IsTemp) {
      return {
        date: true,
        time: true,
        finished: false,
        daysToAdd: daysToAdd
      }
    }
    if (availability.TimeStart) {
      availability.TimeStart =  utils.minutesToHHMM(availability.TimeStart)
    }
    if (availability.TimeEnd) {
      availability.TimeEnd =  utils.minutesToHHMM(availability.TimeEnd)
    }
    const isDebug = false;

    const result = {
      date: false,
      time: false,
      finished: false,
      daysToAdd: daysToAdd
    }
    let dToday = new Date();
    dToday = new Date(dToday.getFullYear(), dToday.getMonth(), dToday.getDate(), 0, 0, 0);
    const dActual = new Date().setDate(dToday.getDate() + parseInt(daysToAdd, 10));

    // verificamos el hora
    if (availability.IsAllTimes === 1) {
      result.time = true;
    } else {
      const startSplit = availability.TimeStart === 0 ? ['00','00'] : availability.TimeStart.split(':') // solve bug 00:00 = 0
      const hIni = parseInt(startSplit[0], 10);
      const mIni = parseInt(startSplit[1], 10);
      const ini = hIni * 60 + mIni;
      const endSplit = availability.TimeEnd.split(':');
      // const hEnd = parseInt(endSplit[0], 10);
      const hEnd = parseInt(endSplit[0] === '00' ? '24' : endSplit[0], 10);
      const mEnd = parseInt(endSplit[1], 10);
      const end = hEnd * 60 + mEnd;
      const nowSplit = new Date().toLocaleTimeString("es-ES", { timeZone: timeZone }).split(':');
      const hNow = parseInt(nowSplit[0], 10);
      const mNow = parseInt(nowSplit[1], 10);
      const now = hNow * 60 + mNow;
      if (ini <= now && end >= now) {
        result.time = true;
      }
      if (daysToAdd === '0' && end <= now) result.finished = true
      // console.log('jhm', timeZone, daysToAdd, end,now,'-----',  new Date().toLocaleTimeString("es-ES", {timeZone: timeZone}))
      if (isDebug) console.log(`Time:${hIni}:${mIni}-${hEnd}:${mEnd} -> [${ini}-${now}-${end}]`);
    }

    // [X] PER = 1 fecha evento
    // [X] PER = 2 recurrencia
    // [X] REC = 1 semana
    // [X] REC = 0 mes
    // [X] PER = 0 fecha inicio-fin

    if (availability.Per === 1) {
      if (isDebug) console.log('Entra por Evento');
      // ################################# fecha evento
      const dEvent = Date.parse(availability.Date, 'Y-m-d');

      result.date = (
        new Date(dEvent).getMonth() === new Date(dActual).getMonth() &&
        new Date(dEvent).getDate() === new Date(dActual).getDate() &&
        new Date(dEvent).getFullYear() === new Date(dActual).getFullYear()
      );
    } else if (availability.Per === 2 || availability.Per === 0) {
      if (isDebug) console.log('DateStart: ', availability.DateStart);
      if (isDebug) console.log('DateEnd: ', availability.DateEnd);

      let dStart = Date.parse(availability.DateStart, 'Y-m-d');
      let dEnd = Date.parse(availability.DateEnd, 'Y-m-d');

      // INI RepeatAnnually
      if (availability.Per === 2 && availability.IsRepeatAnnually && availability.Rec == 0) {
        const yearDiff = new Date().getFullYear() - parseInt(availability.DateStart.toString().substring(0, 4))
        if (yearDiff > 0) {
          let y = parseInt(availability.DateStart.toString().split('-')[0]) + yearDiff;
          let m = parseInt(availability.DateStart.toString().split('-')[1]);
          let d = parseInt(availability.DateStart.toString().split('-')[2]);
          dStart = Date.parse(''.concat(y.toString(), '-', ("000" + m.toString()).slice(-2), '-', ("000" + d.toString()).slice(-2)), 'Y-m-d');
          y = parseInt(availability.DateEnd.toString().split('-')[0]) + yearDiff;
          m = parseInt(availability.DateEnd.toString().split('-')[1]);
          d = parseInt(availability.DateEnd.toString().split('-')[2]);
          dEnd = Date.parse(''.concat(y.toString(), '-', ("000" + m.toString()).slice(-2), '-', ("000" + d.toString()).slice(-2)), 'Y-m-d');
          //console.log(''.concat(y.toString(),'-', ("000" + m.toString()).slice(-2),'-',("000" + d.toString()).slice(-2)))
        }
      }
      // END RepeatAnnually

      if (dActual >= dStart && (dActual <= dEnd || availability.IsAllDays === 1)) {
        // validamos la fecha de inicio
        if (availability.Per === 2) {
          if (isDebug) console.log('Entra por Recurrencia');
          // ################################# recurrencia
          if (availability.Rec === 1) {
            if (isDebug) console.log('Entra por Semana');
            // --------------------------------- semana
            const dayWeek = new Date(dActual).getUTCDay()
            if (isDebug) console.log('jhm', daysToAdd, new Date(dActual), JSON.parse(availability.DayOfWeek), dayWeek)
            // if (JSON.parse(availability.DayOfWeek).indexOf(dayWeek) >= 0 && utils.alternation(new Date(dStart), new Date(dActual), availability.Alt, false)) result.date = true
            if (JSON.parse(availability.DayOfWeek).indexOf(dayWeek) >= 0 && system.alternation(availability.DateStart, daysToAdd, availability.Alt, false)) result.date = true
            
          } else {
            if (isDebug) console.log('Entra por Mes');
            // --------------------------------- mes
            const dayMonth = new Date(dActual).getDate();
            // if (JSON.parse(availability.DayOfMonth).indexOf(dayMonth) >= 0 && utils.alternation(new Date(dStart), new Date(dActual), availability.Alt, true)) result.date = true
            if (JSON.parse(availability.DayOfMonth).indexOf(dayMonth) >= 0 && system.alternation(availability.DateStart, daysToAdd, availability.Alt, false)) result.date = true
          }

        } else {
          if (isDebug) console.log('Entra por INI-FIN');
          // ################################# fecha inicio-fin
          result.date = true;
        }
      }
    }

    return result;
  }
}

export default dview
// module.exports = dview
